import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EcaadminDashboardService } from '../ecaadmin-dashboard/ecaadmin-dashboard.service';
// import {SocketService} from '../socket.service';

@Component({
  selector: 'app-ecaadmin-login',
  templateUrl: './ecaadmin-login.component.html',
  styleUrls: ['./ecaadmin-login.component.css']
})
export class EcaadminLoginComponent implements OnInit {
  adminEmail = '';
  adminPassword = '';
  invalidCredentialsError = false;

  constructor(
    private router: Router,
    private  ecaadminDashboardService:  EcaadminDashboardService,
    // public SocketService: SocketService
  ) {}

  ngOnInit(): void {
    this.invalidCredentialsError = false;
    // this.SocketService.webSocketConnect().subscribe(() => {
    //   console.log("Ffffff");
    // })
  }

  onAdminLogin() {
    this.invalidCredentialsError = false;
    this.ecaadminDashboardService.login({email:this.adminEmail,password:this.adminPassword}).subscribe((dataResult: any)=>{
     console.log("gggg",dataResult);
      if(dataResult.success===false){
        this.invalidCredentialsError=true;
      }
      else{
        if(dataResult.data.userType=='ADMIN'){
          localStorage.setItem('token',dataResult.token);
          localStorage.setItem('name', dataResult.data.name);
          localStorage.setItem('userId', dataResult.data._id);
          this.router.navigate(['/ecademic/admin']);
        }
        else if(dataResult.data.userType=='SUBADMIN'){
          localStorage.setItem('token',dataResult.token);
          localStorage.setItem('name', dataResult.data.name);
          localStorage.setItem('userId',dataResult.data._id);
          this.router.navigate(['/ecademic/sub-admin']);
        }
        else {
          this.invalidCredentialsError = true;
        }
      }
    })
    // if (this.adminEmail == 'admin@gmail.com' && this.adminPassword == 'admin') {
    //   console.log("admin valid");
    //   this.router.navigate(['/admin']);
    // } else if (this.adminEmail == 'subadmin@gmail.com' && this.adminPassword == 'subadmin') {
    //   this.router.navigate(['/sub-admin']);
    // } else {
    //   this.invalidCredentialsError = true;
    // }
  }
}
